module.exports = __webpack_public_path__ + "static/pinkfairy5-87daf34f39ec3126738a2a8acbeeb2e3.png";